var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"printers"},[(_vm.loaded)?_c(_vm.isAllegra ? 'AllegraPrintersSettings' : 'AriaPrintersSettings',{tag:"component",attrs:{"predefined-printers":_vm.predefinedPrinters,"server-print-config":_vm.serverPrintConfig}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }